<template>
  <div>HERE</div>
</template>

<script>
export default {
  name: 'LabelSizeSelector',
  props: {
    value: Number,
  },
  data () {
    return {}
  }
}
</script>